import React, { useEffect, useRef, useState } from 'react';
import Moment from 'moment'; // NEW - used for Last Modified display
import { useDispatch, useSelector } from 'react-redux';
import { CustomDropdown } from '../../../common/custom-form/custom-dropdown.component';
import { TRANSLATIONS, CONFIRMATION_VALUE } from '../../../../utils/constant.utils'; // UPDATED - added CONFIRMATION_VALUE
import { TabberButton } from '../../../common/custom-form/tabber-button.component';
import { SelectFieldFloatingLabel as Select } from '../../../common/custom-form/select-filter.component';
import { Button } from "react-bootstrap";
import ButtonIcon from '../../../button'; // NEW - same button used by UploadButton
import Translation from '../../../common/translation/translation.component';
import TableWithButton from '../../../common/details-table/table-with-button.component';
import { ConfirmationNotificationModal } from '../../../common/modal/confirmation-modal.component'; // NEW
import { NotificationModal } from '../../../common/modal/notification-modal.component'; // NEW
import { KyberConfigActions } from '../../../../store/common/chatbot/kyberconfig/kyberconfig.reducer'; // NEW
import { convertToTimeZoneDate } from '../../../../utils/helpers.utils'; // NEW - used for Last Modified display
// NEW - confirmation message used before downloading KB article
import { MODAL_CUSTOM_MESSAGE } from '../../../../constants/external-constants';

// UPDATED - Converse Using FAQ only supports Yes and No
const FAQ_OPTIONS = [
    { Key: 'true', Value: 'Yes' },
    { Key: 'false', Value: 'No' },
];

// UPDATED - table is now populated from API instead of sample data
const CHATBOT_ARTICLE_TABLE_HEADER = [
    {
        Filename: { propName: 'Filename', name: 'Filename', order: 0, hidden: false },
        UploadDate: { propName: 'UploadDate', name: 'Upload Date', order: 1, hidden: false },
        Status: { propName: 'Status', name: 'Status', order: 2, hidden: false },
        LastModified: { propName: 'LastModified', name: 'Last Modified', order: 3, hidden: false },
    },
];

const KbArticle_FILE_FORMATS = ['CSV', 'XLS', 'XLSX', 'DOC', 'DOCX', 'PDF', 'TXT'];
const KbArticle_MAX_FILE_SIZE_MB = 10;
const CHATBOT_KB_ARTICLE_LIMIT = 20;
const CHATBOT_KB_ARTICLE_DEFAULT_PAGE_SIZE = 10;

// options for the inline row-edit Status dropdown
const ROW_STATUS_OPTIONS = [
    { Key: 'Active', Value: 'Active' },
    { Key: 'Inactive', Value: 'Inactive' },
];

const ChatBotForm = ({ kyberAgentEnabled }) => {
    const dispatch = useDispatch(); // NEW
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [enableAgent, setEnableAgent] = useState(false);
    const [selectedFAQ, setSelectedFAQ] = useState('');
    const [kbArticle, setKbArticle] = useState('');

    const [exportAlertMsg] = useState(
        MODAL_CUSTOM_MESSAGE.export_alert_message
    );

    // NEW - selected KB article metadata
    const [kbArticleDetails, setKbArticleDetails] = useState({
        fileName: '',
        filePath: '',
        fileExtension: '',
        fileSize: null
    });

    // UPDATED - initialize empty; populated from API
    const [dataTable, setDataTable] = useState([
        { HeaderItem: CHATBOT_ARTICLE_TABLE_HEADER, dataItem: [] },
    ]);

    const [ articleSort, setArticleSort] = useState({
        propName: 'UploadDate',
        direction: 'ascending'
    });

    const [enableEdit, setEnableEdit] = useState(false);
    const [keyIndex, setKeyIndex] = useState(null);
    const [editedRowValues, setEditedRowValues] = useState({});

    // NEW - newly added KB articles are kept locally until bottom Save is clicked
    const [pendingAddedArticles, setPendingAddedArticles] = useState([]);

    // NEW - article updates are held locally until bottom Save is clicked
    const [pendingArticleUpdates, setPendingArticleUpdates] = useState([]);

    // NEW - deleted article IDs are held locally until bottom Save is clicked
    const [pendingDeletedArticleIds, setPendingDeletedArticleIds] = useState([]);

    // NEW - row waiting for edit confirmation
    const [pendingUpdateIndex, setPendingUpdateIndex] = useState(null);

    // NEW - controls edit confirmation modal
    const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);

    // Row waiting for delete confirmation.
    const [pendingDeleteIndex, setPendingDeleteIndex] = useState(null);

    // Controls the delete confirmation modal.
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    // NEW - success/error notification
    const [saveNotif, setSaveNotif] = useState({
        show: false,
        title: "",
        message: ""
    });

    // NEW - disables Save while saving
    const [isSaving, setIsSaving] = useState(false);

    // NEW - original values loaded/saved from SQL.
    // Used to determine whether ChatBot Agent config has unsaved changes.
    const [originalAgentEnabled, setOriginalAgentEnabled] = useState(false);
    const [originalConverseUsingFaq, setOriginalConverseUsingFaq] = useState('true');

    const tabberButtonRef = useRef(null);

    // NEW - AC5 to AC10
    // ChatBot-specific file input so shared UploadButton does not need changes.
    const kbFileInputRef = useRef(null);

    // NEW - AC8
    // Actual currently selected valid File.
    const selectedKbFileRef = useRef(null);

    // NEW - AC9
    // Replacement File waiting for Yes / No confirmation.
    const pendingReplacementFileRef = useRef(null);

    // NEW - AC9
    const [showReplaceFileConfirmation, setShowReplaceFileConfirmation] =
        useState(false);

    // NEW - AC10
    const [showClearFileConfirmation, setShowClearFileConfirmation] =
        useState(false);

    // NEW - AC5, AC6, AC7
    const [uploadValidationNotif, setUploadValidationNotif] = useState({
        show: false,
        message: ""
    });

    const { locale } = useSelector(state => state.translation);

    // NEW - timezone used for Last Modified display
    const { activeTimeZoneOffset } = useSelector(state => state.adminSetting);

    // NEW - ChatBot Agent configuration from Redux
    const {
        agentEnabled,
        converseUsingFaq,
        articles
    } = useSelector(state => state.kyberConfig?.chatBotAgent ?? {
        agentEnabled: false,
        converseUsingFaq: false,
        articles: []
    });

    // NEW - load ChatBot Agent configuration
    useEffect(() => {
        dispatch(KyberConfigActions.getKyberChatBotAgentConfig());
    }, [dispatch]);

    // UPDATED - initialize current AND original saved values from API
    useEffect(() => {
        const effectiveAgentEnabled = kyberAgentEnabled && agentEnabled;
        const loadedConverseUsingFaq = converseUsingFaq === true
                ? 'true'
                : 'false';

        setEnableAgent(effectiveAgentEnabled);
        setSelectedFAQ(loadedConverseUsingFaq);
        setOriginalAgentEnabled(effectiveAgentEnabled);
        setOriginalConverseUsingFaq(loadedConverseUsingFaq);
    }, [agentEnabled,converseUsingFaq,kyberAgentEnabled]);

    const sortArticleRows = (
        rows,
        propName,
        direction
    ) => {
        const multiplier =
            direction === 'ascending'
                ? 1
                : -1;

        return [...rows].sort((left, right) => {
            let leftValue = left?.[propName] ?? '';
            let rightValue = right?.[propName] ?? '';

            if (propName === 'UploadDate') {
                leftValue = Moment(leftValue,'L LT').valueOf();
                rightValue = Moment(rightValue, 'L LT').valueOf();
            }
            else {
                leftValue = String(leftValue).toLocaleLowerCase();
                rightValue = String(rightValue).toLocaleLowerCase();
            }

            if (leftValue < rightValue) {
                return -1 * multiplier;
            }

            if (leftValue > rightValue) {
                return 1 * multiplier;
            }

            return 0;
        });
    };

    // NEW - populate table using articles returned by API
    useEffect(() => {
        const tableRows = Array.isArray(articles)
            ? articles.map(article => ({
                Key: article.KyberChatBotAgentArticleId,
                Filename: article.FileName ?? '',

                // UPDATED - format API DateTime for display
                UploadDate: article.UploadDate
                    ? `${Moment(article.UploadDate).format('L')} ${Moment(article.UploadDate).format('LT')}`
                    : '',

                // UPDATED - Active/Inactive comes from Status, not State
                Status: article.Status === true ? 'Active' : 'Inactive',

                LastModified: article.LastModified ?? ''
            }))
            : [];

        setDataTable([
            { HeaderItem: CHATBOT_ARTICLE_TABLE_HEADER, dataItem:
                    sortArticleRows(
                        tableRows,
                        'UploadDate',
                        'ascending'
                    )},
        ]);

        setArticleSort({
            propName: 'UploadDate',
            direction: 'ascending'
        });
    }, [articles]);

    const handleArticleSort = (propName) => {
        const nextDirection =
            articleSort.propName === propName &&
                articleSort.direction === 'ascending'
                ? 'descending'
                : 'ascending';

        setDataTable(prev => {
            const updated = [...prev];

            updated[0] = {
                ...updated[0],

                dataItem:
                    sortArticleRows(
                        updated[0].dataItem,
                        propName,
                        nextDirection
                    )
            };

            return updated;
        });

        setArticleSort({
            propName: propName,
            direction: nextDirection
        });
    };

    const translator = (key, isCapitalize = true) => {
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return isCapitalize ? TRANSLATIONS[locale][key]?.toUpperCase() : TRANSLATIONS[locale][key];
    }

    const handleToggle = () => {
        setIsCollapsed(prev => !prev);
    }

    const handleSelectedFAQ = (fieldProp, value) => {
        // UPDATED - values are "true" or "false"
        setSelectedFAQ(String(value));
    }

    // UPDATED - AC10
    const handleCancel = () => {

        if (!selectedKbFileRef.current) {
            return;
        }

        setShowClearFileConfirmation(true);
    }

    // NEW - AC10
    const handleClearFileConfirmation = (buttonType) => {

        /*
        * Selecting No:
        * - close notification
        * - keep current file
        */
        if (buttonType !== CONFIRMATION_VALUE.Ok) {
            setShowClearFileConfirmation(false);
            return;
        }

        /*
        * Selecting Yes:
        * - clear current uploaded file
        * - close notification
        */
        selectedKbFileRef.current = null;
        pendingReplacementFileRef.current = null;

        setKbArticle('');

        setKbArticleDetails({
            fileName: '',
            filePath: '',
            fileExtension: '',
            fileSize: null
        });

        if (kbFileInputRef.current) {
            kbFileInputRef.current.value = '';
        }

        setShowClearFileConfirmation(false);
    }

    const handleClickAddBtn = () => {
        const currentArticleCount = dataTable?.[0]?.dataItem?.length ?? 0;

        if (currentArticleCount >= CHATBOT_KB_ARTICLE_LIMIT)
        {
            showArticleLimitError();
            return;
        }

        if (!kbArticle) {
            return;
        }

        // UPDATED - AC8
        // Use the currently accepted ChatBot Agent File.
        const selectedFile =
            selectedKbFileRef.current;

        if (!selectedFile) {
            return;
        }

        // NEW - actual file size in bytes
        const fileSize =
            selectedFile?.size ?? null;

        // NEW - get original filename from File object when available
        const fileName =
            selectedFile?.name ?? kbArticle;

        // NEW - derive extension from actual filename
        const fileExtension =
            fileName.includes('.')
                ? fileName.split('.').pop()
                : '';

        // NEW - same Last Modified / Upload Date format used by the table
        const currentDate =
            convertToTimeZoneDate(
                new Date(),
                activeTimeZoneOffset?.UtcOffset
            );

        const formattedDate =
            `${Moment(currentDate).format('L')} ${Moment(currentDate).format('LT')}`;

        const lastModified =
            `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${formattedDate}`;

        /*
        * NEW
        *
        * Temporary client-side ID.
        * Existing database IDs are positive, so negative IDs can identify
        * newly added rows that have not been saved to SQL yet.
        */
        const temporaryKey = -(Date.now());

        /*
        * NEW
        *
        * Build the local table row just like Add Cost Allocation
        * builds its local data object before saving.
        */
        const newArticle = {
            Key: temporaryKey,
            Filename: kbArticle,
            UploadDate: formattedDate,
            Status: 'Active',
            LastModified: lastModified
        };

        /*
        * NEW
        *
        * Add to the visible table only.
        * No SQL/API insert happens here.
        */
        setDataTable(prev => {
            const updated = [...prev];

            updated[0] = {
                ...updated[0],
                dataItem:
                    sortArticleRows(
                        [
                            ...updated[0].dataItem,
                            newArticle
                        ],
                        articleSort.propName,
                        articleSort.direction
                    )
            };

            return updated;
        });

        // UPDATED - retain actual File locally until bottom Save
        setPendingAddedArticles(prev => [
            ...prev,
            {
                TemporaryKey:
                    temporaryKey,

                // NEW - never serialized into normal JSON
                File:
                    selectedFile,

                FileName:
                    fileName,

                Status:
                    true
            }
        ]);

        // UPDATED - clear upload controls after adding to table
        setKbArticle('');

        // UPDATED - AC8
        // File has now been added to table.
        selectedKbFileRef.current = null;
        pendingReplacementFileRef.current = null;

        setShowReplaceFileConfirmation(false);
        setShowClearFileConfirmation(false);

        // NEW - clear selected article metadata
        setKbArticleDetails({
            fileName: '',
            filePath: '',
            fileExtension: '',
            fileSize: null
        });

        if (kbFileInputRef.current) {
            kbFileInputRef.current.value = '';
        }
    }

    // UPDATED - Add requires a selected KB article
    const disabledAddBtn = !kbArticle;

    // NEW - AC8
    const applyKbArticleFile = (file) => {

        if (!file) {
            return;
        }

        const fileName =
            file.name;

        selectedKbFileRef.current =
            file;

        setKbArticle(fileName);

        setKbArticleDetails({
            fileName: fileName,

            filePath: '',

            fileExtension:
                fileName.includes('.')
                    ? fileName.split('.').pop()
                    : '',

            fileSize:
                file.size
        });
    }

    const showArticleLimitError = () => {
        setUploadValidationNotif({
            show: true,
            message: MODAL_CUSTOM_MESSAGE.chatbot_article_limit
        });
    };

    // NEW - AC5, AC6, AC7, AC8, AC9
    const handleKbFileChange = (event) => {

        const files =
            Array.from(
                event.target.files || []
            );

        if (files.length === 0) {
            return;
        }

        const currentArticleCount = dataTable?.[0]?.dataItem?.length ?? 0;

        if (currentArticleCount >= CHATBOT_KB_ARTICLE_LIMIT)
        {
            showArticleLimitError();
            event.target.value = '';
            return;
        }

        /*
        * AC5
        * Only one file is allowed.
        */
        if (files.length > 1) {

            setUploadValidationNotif({
                show: true,
                message:
                    'Number of files exceeds the allowable limit of 1'
            });

            event.target.value = '';

            return;
        }

        const file =
            files[0];

        /*
        * AC6
        * Maximum file size = 10 MB.
        */
        if (
            file.size >
            KbArticle_MAX_FILE_SIZE_MB *
            1024 *
            1024
        ) {

            setUploadValidationNotif({
                show: true,
                message:
                    `Total file size exceeds the allowable limit of ${KbArticle_MAX_FILE_SIZE_MB} MB`
            });

            event.target.value = '';

            return;
        }

        /*
        * AC7
        * Validate file format.
        */
        const fileName =
            file.name;

        const extension =
            fileName.includes('.')
                ? fileName
                    .split('.')
                    .pop()
                    .toUpperCase()
                : '';

        if (
            !KbArticle_FILE_FORMATS.includes(
                extension
            )
        ) {

            setUploadValidationNotif({
                show: true,
                message:
                    `Only files with the following format are allowed: ${KbArticle_FILE_FORMATS.join(', ')}`
            });

            event.target.value = '';

            return;
        }

        /*
        * AC9
        *
        * There is already a valid uploaded file
        * which has not yet been added to the table.
        */
        if (selectedKbFileRef.current) {

            pendingReplacementFileRef.current =
                file;

            setShowReplaceFileConfirmation(
                true
            );

            event.target.value = '';

            return;
        }

        /*
        * AC8
        * First valid file.
        */
        applyKbArticleFile(
            file
        );

        event.target.value = '';
    }

    // NEW - AC9
    const handleReplaceFileConfirmation = (buttonType) => {

        /*
        * Selecting No:
        * - close notification
        * - keep current file
        */
        if (buttonType !== CONFIRMATION_VALUE.Ok) {

            pendingReplacementFileRef.current = null;

            setShowReplaceFileConfirmation(false);

            return;
        }

        /*
        * Selecting Yes:
        * - disregard current file
        * - use newly selected file
        */
        const replacementFile =
            pendingReplacementFileRef.current;

        if (!replacementFile) {
            setShowReplaceFileConfirmation(false);
            return;
        }

        applyKbArticleFile(
            replacementFile
        );

        pendingReplacementFileRef.current = null;

        setShowReplaceFileConfirmation(false);
    }

    const handleClickExtract = () => {
        // TODO - connect to existing extract/upload implementation if required
    }

    const handleDeleteRow = (index) => {
        const row =dataTable?.[0]?.dataItem?.[index];

        if (!row) {
            return;
        }
        setPendingDeleteIndex(index);
        setShowDeleteConfirmation(true);
    };

    const applyDeleteRow = (index) => {

        const row = dataTable?.[0]?.dataItem?.[index];

        if (!row) {
            return;
        }

        /*
        * UPDATED
        *
        * Positive Key = existing database record.
        * Negative Key = newly added local record.
        */
        if (row.Key > 0) {

            // Existing SQL record - remember for soft delete during Save
            setPendingDeletedArticleIds(prev => [
                ...new Set([
                    ...prev,
                    row.Key
                ])
            ]);

            // Remove any pending status update for the same record
            setPendingArticleUpdates(prev =>
                prev.filter(x =>
                    x.KyberChatBotAgentArticleId !== row.Key
                )
            );
        }
        else {

            // NEW - unsaved article; just remove it from pending additions
            setPendingAddedArticles(prev =>
                prev.filter(x =>
                    x.TemporaryKey !== row.Key
                )
            );
        }

        // UPDATED - remove from UI only
        setDataTable(prev => {
            const updated = [...prev];

            updated[0] = {
                ...updated[0],
                dataItem: updated[0].dataItem.filter((_, i) => i !== index)
            };

            return updated;
        });
    }

    const handleDeleteConfirmation = (buttonType) => {
        if (buttonType !== CONFIRMATION_VALUE.Ok)
        {
            setShowDeleteConfirmation(false);
            setPendingDeleteIndex(null);
            return;
        }

        if (pendingDeleteIndex === null) {
            setShowDeleteConfirmation(false);
            return;
        }

        applyDeleteRow(pendingDeleteIndex);

        setShowDeleteConfirmation(false);
        setPendingDeleteIndex(null);
    };

    const handleUpdateRow = (index) => {
        // UPDATED
        // Check button only opens confirmation.
        // No SQL update happens here.
        setPendingUpdateIndex(index);
        setShowUpdateConfirmation(true);
    }

    // UPDATED - confirmation after clicking the check icon
    const handleUpdateConfirmation = (buttonType) => {

        if (buttonType !== CONFIRMATION_VALUE.Ok) {
            setShowUpdateConfirmation(false);
            setPendingUpdateIndex(null);
            return;
        }

        const row = dataTable?.[0]?.dataItem?.[pendingUpdateIndex];

        if (!row) {
            setShowUpdateConfirmation(false);
            setPendingUpdateIndex(null);
            return;
        }

        const updatedStatus =
            editedRowValues.Status ?? row.Status;

        // NEW - display format:
        // FirstName LastName on MM/DD/YYYY h:mm AM/PM
        const currentDate =
            convertToTimeZoneDate(
                new Date(),
                activeTimeZoneOffset?.UtcOffset
            );

        const lastModified =
            `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(currentDate).format('L')} ${Moment(currentDate).format('LT')}`;

        /*
        * NEW
        *
        * Find the original article returned by the API.
        *
        * This allows us to determine whether the user changed
        * the article back to its original saved Status.
        */
        const originalArticle =
            row.Key > 0
                ? articles.find(article =>
                    Number(
                        article.KyberChatBotAgentArticleId
                    ) === Number(
                        row.Key
                    )
                )
                : null;

        // NEW - original saved Status
        const originalStatus =
            originalArticle
                ? originalArticle.Status === true
                    ? 'Active'
                    : 'Inactive'
                : null;

        /*
        * NEW
        *
        * Example:
        *
        * Saved Status = Active
        *
        * Active -> Inactive = change
        * Inactive -> Active = reverted, no change
        */
        const revertedToOriginal =
            row.Key > 0 &&
            originalStatus === updatedStatus;

        // UPDATED - change table locally only
        setDataTable(prev => {
            const updated = [...prev];
            const dataItem = [...updated[0].dataItem];

            dataItem[pendingUpdateIndex] = {
                ...dataItem[pendingUpdateIndex],

                Status:
                    updatedStatus,

                /*
                * UPDATED
                *
                * If Status was reverted to its original value,
                * restore the Last Modified value returned by SQL/API.
                */
                LastModified:
                    revertedToOriginal
                        ? originalArticle?.LastModified ?? ''
                        : lastModified
            };

            updated[0] = {
                ...updated[0],
                dataItem: dataItem
            };

            return updated;
        });

        /*
        * UPDATED
        *
        * Existing DB article and newly added local article
        * are tracked separately.
        */
        if (row.Key > 0) {

            /*
            * UPDATED
            *
            * If the user reverted the Status to the original
            * saved value, this article is no longer changed.
            */
            if (revertedToOriginal) {

                setPendingArticleUpdates(prev =>
                    prev.filter(x =>
                        x.KyberChatBotAgentArticleId !==
                            row.Key
                    )
                );
            }
            else {

                // Existing database article
                setPendingArticleUpdates(prev => {

                    const newUpdate = {
                        KyberChatBotAgentArticleId:
                            row.Key,

                        Status:
                            updatedStatus === 'Active'
                    };

                    const existingIndex =
                        prev.findIndex(x =>
                            x.KyberChatBotAgentArticleId ===
                                row.Key
                        );

                    if (existingIndex >= 0) {
                        const updated = [...prev];

                        updated[existingIndex] =
                            newUpdate;

                        return updated;
                    }

                    return [
                        ...prev,
                        newUpdate
                    ];
                });
            }
        }
        else {

            // NEW - update newly added article before it reaches SQL
            setPendingAddedArticles(prev =>
                prev.map(article =>
                    article.TemporaryKey === row.Key
                        ? {
                            ...article,
                            Status: updatedStatus === 'Active'
                        }
                        : article
                )
            );
        }

        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);

        setShowUpdateConfirmation(false);
        setPendingUpdateIndex(null);
    }

    const handleEnableEdit = (enable, index) => {
        setEnableEdit(enable);
        setKeyIndex(index);

        if (!enable) {
            setEditedRowValues({});
        }
    }

    const handleRowFieldChange = (propName, e) => {
        const value = e.target.value;
        setEditedRowValues(prev => ({ ...prev, [propName]: value }));
    }

    // NEW - requires confirmation before starting the download
    const handleFileDownload = async (item) => {

        if (
            !item?.Key ||
            item.Key <= 0
        ) {
            return;
        }

        // NEW - same confirmation used by Plan Catalogue
        if (!window.confirm(
            MODAL_CUSTOM_MESSAGE.export_alert_message
        )) {
            return;
        }

        try {

            const response =
                await dispatch(
                    KyberConfigActions
                        .downloadKyberChatBotArticle(
                            item.Key
                        )
                );


            if (!response?.ok) {

                throw new Error(
                    'Unable to download KB article.'
                );
            }


            const blob =
                await response.blob();


            const url =
                window.URL.createObjectURL(
                    blob
                );


            const link =
                document.createElement('a');


            link.href =
                url;

            link.download =
                item.Filename;


            document.body.appendChild(
                link
            );


            link.click();

            link.remove();


            window.URL.revokeObjectURL(
                url
            );
        }
        catch (error) {

            toggleSaveNotif(
                true,
                translator(
                    'modal_error_title',
                    false
                ),
                error?.message ||
                'Unable to download KB article.'
            );
        }
    }
    
    const handleFormCancel = () => {
        // UPDATED
        // Restore saved DB values and discard all unsaved local changes.

        setEnableAgent(agentEnabled === true);

        setSelectedFAQ(
            converseUsingFaq === true ? 'true' : 'false'
        );

        setKbArticle('');

        // UPDATED - AC5 to AC10
        selectedKbFileRef.current = null;
        pendingReplacementFileRef.current = null;

        setShowReplaceFileConfirmation(false);
        setShowClearFileConfirmation(false);

        if (kbFileInputRef.current) {
            kbFileInputRef.current.value = '';
        }

        // NEW - clear selected article metadata
        setKbArticleDetails({
            fileName: '',
            filePath: '',
            fileExtension: '',
            fileSize: null
        });

        // NEW - discard unsaved additions
        setPendingAddedArticles([]);

        setPendingArticleUpdates([]);
        setPendingDeletedArticleIds([]);

        setEditedRowValues({});
        setEnableEdit(false);
        setKeyIndex(null);

        // NEW - reload original table from API/Redux values
        const tableRows = Array.isArray(articles)
        ? articles.map(article => ({
            Key: article.KyberChatBotAgentArticleId,
            Filename: article.FileName ?? '',

            // UPDATED - format API DateTime for display
            UploadDate: article.UploadDate
                ? `${Moment(article.UploadDate).format('L')} ${Moment(article.UploadDate).format('LT')}`
                : '',

            Status: article.Status === true ? 'Active' : 'Inactive',
            LastModified: article.LastModified ?? ''
        }))
        : [];

        setDataTable([
            { HeaderItem: CHATBOT_ARTICLE_TABLE_HEADER, dataItem: tableRows },
        ]);
    }

    const handleClickSaveBtn = async () => {

        if (
            selectedFAQ === '' ||
            isSaving
        ) {
            return;
        }

        // Existing - disable immediately
        setIsSaving(true);

        try {

            const converseUsingFaqValue =
                String(selectedFAQ)
                    .toLowerCase() === 'true';


            /*
            * ========================================================
            * STEP 1
            * SAVE SQL FIRST
            * ========================================================
            *
            * This creates KyberChatBotAgentArticleId.
            */

            const result =
                await dispatch(
                    KyberConfigActions
                        .saveKyberChatBotAgentConfig(
                            enableAgent,
                            converseUsingFaqValue,
                            pendingAddedArticles,
                            pendingArticleUpdates,
                            pendingDeletedArticleIds
                        )
                );


            if (result?.Success !== true) {

                toggleSaveNotif(
                    true,
                    translator(
                        'modal_error_title',
                        false
                    ),
                    result?.Message ||
                    'Unable to save ChatBot Agent configuration.'
                );

                return;
            }


            /*
            * ========================================================
            * STEP 2
            * UPLOAD EACH NEW FILE
            * ========================================================
            */

            const createdArticles =
                result?.AddedArticles ?? [];


            for (const pendingArticle
                of pendingAddedArticles)
            {
                const createdArticle =
                    createdArticles.find(x =>
                        Number(x.TemporaryKey) ===
                        Number(
                            pendingArticle.TemporaryKey
                        )
                    );


                if (!createdArticle) {

                    throw new Error(
                        `Unable to retrieve article ID for ${pendingArticle.FileName}.`
                    );
                }


                if (!pendingArticle.File) {

                    throw new Error(
                        `File data was not found for ${pendingArticle.FileName}.`
                    );
                }


                /*
                * NEW
                *
                * Controller will save Blob as:
                *
                * {KyberChatBotAgentArticleId}/{FileName}
                */
                const uploadResult =
                    await dispatch(
                        KyberConfigActions
                            .uploadKyberChatBotArticle(
                                createdArticle
                                    .KyberChatBotAgentArticleId,

                                pendingArticle.File
                            )
                    );


                if (uploadResult?.Success !== true) {

                    throw new Error(
                        `Unable to upload ${pendingArticle.FileName}.`
                    );
                }
            }


            /*
            * ========================================================
            * STEP 3
            * EVERYTHING COMPLETED
            * ========================================================
            */

            setPendingAddedArticles([]);
            setPendingArticleUpdates([]);
            setPendingDeletedArticleIds([]);

            setEditedRowValues({});
            setEnableEdit(false);
            setKeyIndex(null);


            // NEW - reload only after Blob upload + SQL metadata update
            await dispatch(
                KyberConfigActions
                    .getKyberChatBotAgentConfig()
            );


            toggleSaveNotif(
                true,
                translator(
                    'success_modal_title',
                    false
                ),
                result?.Message ||
                 translator(
                    'kyber_chatbot_agent_saved',
                    false
                ),
            );
        }
        catch (error) {

            toggleSaveNotif(
                true,
                translator(
                    'modal_error_title',
                    false
                ),
                error?.message ||
                'Unable to save or upload the KB article.'
            );
        }
        finally {

            setIsSaving(false);
        }
    }

    // NEW - notification modal helper
    const toggleSaveNotif = (isShow, title = "", message = "") => {
        setSaveNotif({
            show: isShow,
            title: title,
            message: message
        });
    };

    /*
    * UPDATED - Save is enabled only when there are actual unsaved changes.
    *
    * Changes can come from:
    * - Enable Agent
    * - Converse Using FAQ
    * - newly added articles
    * - article Active/Inactive changes
    * - deleted articles
    */
    const configChanged =
        enableAgent !== originalAgentEnabled ||
        selectedFAQ !== originalConverseUsingFaq;

    const articleChanged =
        pendingAddedArticles.length > 0 ||
        pendingArticleUpdates.length > 0 ||
        pendingDeletedArticleIds.length > 0;

    const hasChanges =
        configChanged ||
        articleChanged;

    // NEW - determine whether there are already saved articles
    const hasExistingArticles =
        Array.isArray(articles) &&
        articles.length > 0;

    // NEW - determine whether at least one new article
    // has actually been added to the table
    const hasAddedArticle =
        pendingAddedArticles.length > 0;

    /*
    * UPDATED
    *
    * When enabling the Agent:
    *
    * - if there are existing KB articles, normal change detection applies
    * - if there are no existing KB articles yet, at least one article
    *   must first be added before Save can be enabled
    *
    * Disabling the Agent is still allowed to be saved.
    */
    const requiresArticleBeforeEnabling =
        enableAgent === true &&
        !originalAgentEnabled &&
        !hasExistingArticles &&
        !hasAddedArticle;

    const disabledSaveBtn =
        selectedFAQ === '' ||
        !hasChanges ||
        requiresArticleBeforeEnabling;

    return (
        <div className="kyberconfig-form-container">
          <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={handleToggle} label={translator("chat_bot_agent", false)} toggleStatus={enableAgent} >
            <div className="kyberconfig-form-content">
                    <div className="kyberconfig-toggle-row">

                        <TabberButton
                            key={
                                enableAgent
                                    ? 'chatbot-agent-on'
                                    : 'chatbot-agent-off'
                            }
                            ref={tabberButtonRef}
                            title={
                                <>
                                    {translator(
                                        'enable_agent',
                                        false
                                    )}
                                    <span className="kyber-required">
                                        *
                                    </span>
                                </>
                            }
                            value={enableAgent}
                            onToggle={(isActive) => {
                                setEnableAgent(isActive);
                            }}
                        />

                        <Select
                        className="form-select required"
                        label={translator('converse_using_faq')}
                        value={selectedFAQ}
                        options={FAQ_OPTIONS} // UPDATED - Yes / No only
                        placeholder={translator('select_placeholder', false)}
                        fieldProp='kyberChatBotAgent.converseUsingFaq' // UPDATED
                        onChangeAction={handleSelectedFAQ}
                        disabled={!kyberAgentEnabled || !enableAgent }
                    />
                </div>

                {/* UPDATED - AC5 to AC10 */}
                {/* Reuses existing classes from upload-button.css */}
                <div className="upload-layout-containers">
                    <div className="upload-button-container">
                        <span className="title">
                            UPLOAD KB ARTICLE
                        </span>

                        <div className="upload-button-item">

                            {/* UPDATED - same Choose File button as UploadButton */}
                            <ButtonIcon
                                onClick={() =>
                                    enableAgent &&
                                    kbFileInputRef.current?.click()
                                }
                                isDisable={!kyberAgentEnabled || !enableAgent}
                                iconLeft="cloud-arrow-up"
                                iconSize="17px"
                                customClassName="header-option-list header-filter-button"
                                labelName="Choose File"
                            >
                                <input
                                    className="upload-file-btn"
                                    type="file"
                                    ref={kbFileInputRef}
                                    onChange={handleKbFileChange}
                                    accept={
                                        KbArticle_FILE_FORMATS
                                            .map(ext =>
                                                `.${ext.toLowerCase()}`
                                            )
                                            .join(',')
                                    }
                                    disabled={!kyberAgentEnabled || !enableAgent}

                                    // NEW - required so AC5 can detect
                                    // selection of more than one file.
                                    multiple
                                />
                            </ButtonIcon>

                            {/* UPDATED - reuse existing UploadButton font/style */}
                            <div
                                className={`file-title ${kbArticle ? 'attached-file' : ""} ${!enableAgent ? 'disabled' : ''}`}
                            >
                                {kbArticle || 'no file selected'}
                            </div>

                        </div>
                    </div>
                </div>

                <div className="add-button-container custom-add-button">
                    <div className="btn-tooltiptext">
                        <Button
                            variant="outline-secondary"
                            className="btn-custom-violet-hover-outline"

                            // UPDATED - AC8
                            disabled={!kyberAgentEnabled || !enableAgent || !kbArticle}

                            // UPDATED - AC10
                            onClick={handleCancel}
                        >
                            Clear
                        </Button>
                        {/* <span className="tooltip-text">{<Translation translationKey="" />}</span> */}
                    </div>

                    <div className={'btn-tooltiptext'}>
                        <Button
                            disabled={!kyberAgentEnabled || !enableAgent || disabledAddBtn} // UPDATED
                            onClick={handleClickAddBtn}
                            variant="primary"
                            className="btn-add"
                        >
                            Add
                        </Button>
                        {/* <span className="tooltip-text"><Translation translationKey="" />}</span> */}
                    </div>
                </div>

                <TableWithButton
                        datatable={dataTable}
                        enablePagination={true}
                        pageSize={CHATBOT_KB_ARTICLE_DEFAULT_PAGE_SIZE}
                        pageSizes={[10, 20]}
                        sortableColumns={[
                            'Filename',
                            'UploadDate',
                            'Status',
                            'LastModified'
                        ]}
                        sortPropName={articleSort.propName}
                        sortDirection={articleSort.direction}
                        onColumnSort={handleArticleSort}
                        haveDeleteBtn={kyberAgentEnabled && enableAgent}
                        haveEditBtn={kyberAgentEnabled && enableAgent}
                        deleteAction={handleDeleteRow} // UPDATED - local delete only
                        updateAction={handleUpdateRow} // UPDATED - local update confirmation only
                        searchableDropdownData={[]}
                        inputField={[]}
                        dropdownField={['Status']}
                        dropdownOptionsMap={{ Status: ROW_STATUS_OPTIONS }}
                        optionsMap={[]}
                        downloadableColumn="Filename"
                        onFileDownload={handleFileDownload}
                        selectedItems={editedRowValues}
                        handleSelectChange={() => { }}
                        handleInputChange={handleRowFieldChange}
                        handleOpenNotif={() => { }}
                        handleGetFieldData={() => { }}
                        handelEnableEdit={handleEnableEdit}
                        handleCloseNotif={() => { }}
                        enableEdit={enableEdit}
                        keyIndex={keyIndex}
                        hasError={{}}
                        planComponentError={false}
                        setDefaultError={() => { }}
                />

                {/* NEW - AC9: displayed when another file is selected before Add */}
                <ConfirmationNotificationModal
                    show={showReplaceFileConfirmation}
                    message={
                        'A KB Article is currently uploaded. Uploading another will disregard the current file. Continue?'
                    }
                    title={'Confirmation'}
                    handleModal={handleReplaceFileConfirmation}
                    isDecisionModal={true}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                {/* NEW - AC10: displayed when Clear is clicked */}
                <ConfirmationNotificationModal
                    show={showClearFileConfirmation}
                    message={
                        'A KB Article is currently uploaded. Proceed on clearing the file?'
                    }
                    title={'Confirmation'}
                    handleModal={handleClearFileConfirmation}
                    isDecisionModal={true}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                {/* NEW - AC5, AC6, AC7 */}
                <NotificationModal
                    show={uploadValidationNotif.show}
                    title={'Error'}
                    message={uploadValidationNotif.message}
                    handleModal={() =>
                        setUploadValidationNotif({
                            show: false,
                            message: ''
                        })
                    }
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />
                    {/* Displayed after clicking the delete icon */}
                    <ConfirmationNotificationModal
                        show={showDeleteConfirmation}
                        message={
                            MODAL_CUSTOM_MESSAGE.delete
                        }
                        title={'Delete'}
                        handleModal={
                            handleDeleteConfirmation
                        }
                        isDecisionModal={true}
                        customClass={
                            'comment-notification-modal modal-text-bold'
                        }
                    />
                    {/* NEW - displayed after clicking the check icon */}
                    <ConfirmationNotificationModal
                        show={showUpdateConfirmation}
                        message={
                            MODAL_CUSTOM_MESSAGE.update_details
                        }
                        title={'Update'}
                        handleModal={handleUpdateConfirmation}
                        isDecisionModal={true}
                        customClass={'comment-notification-modal modal-text-bold'}
                    />

                {/* NEW - displayed after bottom Save succeeds/fails */}
                <NotificationModal
                    show={saveNotif.show}
                    title={saveNotif.title}
                    message={saveNotif.message}
                    handleModal={() => toggleSaveNotif(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />

                 <div className="add-button-container custom-add-button justify-content-end">
                    <div className="btn-tooltiptext">
                            <Button variant="outline-secondary" className="btn-custom-violet-hover-outline"
                                disabled={!kyberAgentEnabled || !enableAgent
                            } onClick={handleFormCancel}>Cancel</Button>
                        {/* <span className="tooltip-text">{<Translation translationKey="" />}</span> */}
                    </div>

                    <div className={'btn-tooltiptext'}>
                            <Button
                                disabled={
                                    !kyberAgentEnabled ||
                                    disabledSaveBtn ||
                                    isSaving
                                }
                            onClick={handleClickSaveBtn}
                            variant="primary"
                            className="btn-add"
                        >
                            Save
                        </Button>
                        {/* <span className="tooltip-text"><Translation translationKey="" />}</span> */}
                    </div>
                </div>
            </div> 
            
          </CustomDropdown>
        </div>
    );
};


export default ChatBotForm;